import { createFeature, createReducer, on } from '@ngrx/store';
import { ReminderDeliveryModel } from '@shared/data-access/models';
import { PaymentReminderDeliveryAction } from '../actions';

export const featureName = 'paymentReminderDelivery';

export interface DataState {
  detail: ReminderDeliveryModel | null;
}
export const initialState: DataState = {
  detail: null,
};
export const paymentReminderDeliveryFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(PaymentReminderDeliveryAction.getDetail, (state, prop: { item: ReminderDeliveryModel }) => ({ ...state, detail: prop.item }))
  ),
});

export const {
  name,
  reducer,
} = paymentReminderDeliveryFeature;
